export default "__VITE_ASSET__BD1A8AHS__"